var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('olb-button',{attrs:{"linkStyle":"","href":_vm.href}},[_c('olb-icon',{staticClass:"text-icon-sm leading-1",attrs:{"name":"arrow-nav-left"}}),_c('span',{staticClass:"block pb-px"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }